import { render, staticRenderFns } from "./TodoTask.vue?vue&type=template&id=b6d50bac&"
import script from "./TodoTask.vue?vue&type=script&lang=js&"
export * from "./TodoTask.vue?vue&type=script&lang=js&"
import style0 from "./TodoTask.vue?vue&type=style&index=0&id=b6d50bac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports